<div
  *transloco="let t"
  class="card-header w-100 border-0 pt-6 d-block gap-2 flex-wrap flex-lg-nowrap align-items-end flex-column"
>
  <div
    class="d-flex gap-3 align-items-start flex-grow-1 flex-column flex-sm-row"
  >
    <div
      [class]="gridColumnsClass()"
      class="card-title w-100 gap-3 flex-wrap m-0 grid-filter"
    >
      @for (filter of getVisibleFilters(); track filter.controlName) {
        <ng-container *ngTemplateOutlet="filter.template"></ng-container>
      }
    </div>

    <div class="d-flex gap-3 align-items-start w-100 w-sm-auto">
      @if (hasHiddenFilters()) {
        <ui-button
          [ngbPopover]="popContent"
          [autoClose]="'outside'"
          [placement]="isMobileScreen() ? 'bottom' : 'bottom-end'"
          [icon]="'filter'"
          [severity]="'primary'"
          [btnClass]="'filter-btn w-100'"
          [class]="'w-100'"
          [tooltipText]="filterButtonTooltip()"
        ></ui-button>
      }

      @if (hasAnyValue()) {
        <ui-button
          [tooltipText]="
            isTranslate() ? t(clearButtonText()) : clearButtonText()
          "
          [icon]="'filter-edit'"
          [severity]="'warning'"
          [iconClass]="'fs-4 text-black'"
          [btnClass]="'filter-btn w-100'"
          [class]="'w-100'"
          (click)="onClearFilters()"
        ></ui-button>
      }
    </div>
  </div>

  <ng-template #popContent>
    <div class="pt-2 pb-4 px-4">
      @for (filter of getHiddenFilters(); track filter.controlName) {
        <ng-container
          *ngTemplateOutlet="
            filter.template;
            context: {
              form: form(),
              onCloseSelect: onCloseSelect.bind(this),
            }
          "
        ></ng-container>
      }
    </div>
  </ng-template>
</div>
